<template>
  <div>
    <shipment-profile-filters
      :id.sync="payload.id"
      :name.sync="payload.name"
      :method.sync="payload.method"
      @apply="getShipmentProfiles(payload)"
    />
    <loading v-show="loading" />
    <v-card v-show="!loading" elevation="4">
      <v-app-bar flat dense elevation="0" color="transparent">
        <v-toolbar-title> <h4>Shipment Profiles</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <template>
          <v-data-table
            :headers="headers"
            :items="shipmentProfiles"
            show-select
            v-model="selected"
            :server-items-length="totalItems"
            :options.sync="pagination"
            :items-per-page="pagination.itemsPerPage"
            @pagination="updatePagination"
            :disable-pagination="false"
            :footer-props="{
              disablePagination: false,
              disableItemsPerPage: false
            }"
            class="elevation-0 black--text"
            @click:row="edit($event.id)"
          >
            <template v-slot:header.data-table-select="{ props, on }">
              <!-- COLOR Not working when props.indeterminate is true -->
              <v-simple-checkbox
                color="primary"
                v-ripple
                v-bind="props"
                v-on="on"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.data-table-select="{ isSelected, select }">
              <v-simple-checkbox
                color="primary"
                v-ripple
                :value="isSelected"
                @input="select($event)"
              ></v-simple-checkbox>
            </template>

            <template v-slot:item.method="{ item }">
              {{ item.method.replace("_", " ") }}
            </template>

            <template v-slot:item.action="{ item }" v-if="actions">
              <v-menu offset-y bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark icon v-bind="attrs" v-on="on">
                    <v-icon class="gray--text">more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item link>
                    <v-list-item-title @click="edit(item.id)"
                      >Detail</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item link>
                    <v-list-item-title @click="deleteAndRefresh(item.id)"
                      >Delete</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </template>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
// eslint max-nested-callbacks: ["error", 10]
import Helpers from "@/mixins/helpers.js";
import ShipmentProfileFilters from "./ShipmentProfileFilters";
export default {
  props: {
    payload: {
      type: Object,
      default: () => {
        return {
          from: 0,
          to: 10,
          id: null,
          name: null,
          method: null
        };
      }
    },
    module: {
      type: String,
      default: "shipmentprofiles/LOAD_SHIPMENT_PROFILES"
    },
    actions: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ShipmentProfileFilters
  },
  mixins: [Helpers],
  data() {
    let vm = this;
    return {
      supplierId: null,
      loading: true,
      selected: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: false,
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      headers: [
        {
          text: "ID",
          align: "left",
          value: "id",
          sortable: false
        },
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Method",
          align: "left",
          value: "method"
        },
        { text: "", value: "action", align: "right" }
      ]
    };
  },
  computed: {
    shipmentProfiles() {
      return this.$store.state.shipmentprofiles.shipmentProfiles;
    },
    totalItems() {
      return this.$store.state.shipmentprofiles.total;
    }
  },
  watch: {
    selected(val) {
      val.length > 0
        ? this.$emit("enable-action")
        : this.$emit("disable-action");
    }
  },
  created() {
    if (this.actions == false) {
      this.headers = this.headers.filter(column => column.value !== "action");
    }
    setTimeout(() => {
      this.getShipmentProfiles(this.payload);
    }, 1000);
  },
  methods: {
    getShipmentProfiles(payload) {
      this.$store
        .dispatch(this.module, payload)
        .then(response => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
          this.$swal("error", error.message, "error");
        });
    },
    updatePagination(pagination) {
      let payload = this.payload;
      payload.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage;
      payload.to =
        pagination.itemsPerPage === -1
          ? this.totalItems
          : pagination.itemsPerPage;
      console.log(payload);
      this.getShipmentProfiles(payload);
    },
    async deleteAndRefresh(id) {
      let res = await this.destroy(id);
      if (res) {
        let payload = {
          from:
            this.pagination.page * this.pagination.itemsPerPage -
            this.pagination.itemsPerPage,
          to:
            this.pagination.itemsPerPage === -1
              ? this.totalItems
              : this.pagination.itemsPerPage
        };
        this.getShipmentProfiles(payload);
      }
    }
  }
};
</script>
